package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Overflow.AUTO
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Size.Companion.vh
import com.downdogapp.Size.INHERIT
import com.downdogapp.client.controllers.start.Page
import com.downdogapp.client.views.start.SideBarMenuView
import com.downdogapp.client.views.start.SideBarMenuView.Companion.sidebarMenuView
import kotlinx.dom.clear
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import kotlin.contracts.InvocationKind.EXACTLY_ONCE
import kotlin.contracts.contract

class Foreground(parent: HTMLElement, hasSidebar: Boolean) {

  private val sidebar: SideBarMenuView?
  val content: HTMLDivElement

  private val root = createDiv {
    position = ABSOLUTE
    height = INHERIT
    width = INHERIT

    if (hasSidebar) {
      horizontalFlexBox {
        sidebar = sidebarMenuView()
        content = div {
          flexGrow = 1.0
          height = vh(100)
          overflowY = AUTO
        }
      }
    } else {
      sidebar = null
      content = div {
        height = vh(100)
        overflowY = AUTO
      }
    }
  }

  init {
    parent.appendChild(root)
  }

  fun setSelectedPage(page: Page) {
    content.clear()
    content.append(page.view.root)
    refresh()
  }

  fun refresh() {
    sidebar?.refreshView()
  }

  inline fun applyContentBlock(block: HTMLDivElement.() -> Unit) {
    contract {
      callsInPlace(block, EXACTLY_ONCE)
    }
    content.block()
  }
}
